<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <DailyDepositReportTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import DailyDepositReportTable from './DailyDepositTable.vue'

  export default {
    name: 'dailydepositreport-table',
    components: {DailyDepositReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/payment/DailyDeposit.vue